import { memo, useMemo } from 'react'
import { ITaskGroup } from '../../../../../types/tasks.types'
import { useRecoilValue } from 'recoil'
import sandboxAtom from '../../../../Sandbox/sandbox.atom'
import navCss from '../../../navigation.module.css'
import navigationAtom from '../../../navigation.atom'
import useNavigationActions from '../../../useNavigationActions'
import useFlip from '../../../../../hooks/useFlip'
import useDnD from '../../../../../hooks/useDnD'
import sandboxUtils from '../../../../Sandbox/sandbox.utils'
import groupsService from '../../../../../services/groups.service'

interface IProps {
  group: ITaskGroup
  index: number
}

const StarTile = (props: IProps) => {
  const { updatesGroupsOrdering } = useNavigationActions()
  const { element: ref } = useFlip([props.group])

  const sandboxState = useRecoilValue(sandboxAtom)

  const rocketGroups = useMemo(() => {
    return sandboxState.groups.filter((g) => g.set === props.group.set)
  }, [props.group, sandboxState.groups])

  const handleSwap = (droppedId: ITaskGroup['id']) => {
    const updatedGroups = sandboxUtils.immutableMoveGroups(props.group.id, droppedId, rocketGroups)

    updatesGroupsOrdering(updatedGroups)
    for (const g of updatedGroups) groupsService.updateGroup(g.id, { orderingIndex: g.orderingIndex })
  }

  const dnd = useDnD({
    ref: ref,
    id: props.group.id,
    onDrop: handleSwap,
    prefix: '/stars',
    style: { border: '2px solid var(--purple)' },
  })

  const { star } = useRecoilValue(navigationAtom)
  const { toStar } = useNavigationActions()

  const groupTasks = sandboxState.tasks.filter((t) => t.group === props.group.id)

  return (
    <div className={navCss.starWrapper}>
      <div
        data-active={props.group.id === star}
        onClick={() => toStar(props.group.id)}
        className={navCss.star}
        style={{ backgroundImage: `url("${stars[indexToColor[props.index]]}")` }}
        ref={ref}
        {...dnd}
        draggable={true}
      />
      <div className={navCss.fillIndicatorsBlock}>
        {groupTasks
          .filter((t) => t.type !== 8 && t.type !== 16)
          .map((t) => (
            <div
              key={t.id}
              data-active={Boolean(
                Boolean(t.answerOptions.length) ||
                  Boolean(t.wordToMatch) ||
                  t.audio.some((a) => a.rightAnswer) ||
                  t.images.some((image) => image.rightAnswer) ||
                  (t.type === 10 && t.images.length)
              )}
              className={navCss.fillIndicator}
            />
          ))}
      </div>
    </div>
  )
}

const stars = {
  brown: require('../../../../../asserts/stars/Star-Active-Brown.png'),
  blue: require('../../../../../asserts/stars/Star-Active-Blue.png'),
  darkGreen: require('../../../../../asserts/stars/Star-Active-DarkGreen.png'),
  green: require('../../../../../asserts/stars/Star-Active-Green.png'),
  lightBrown: require('../../../../../asserts/stars/Star-Active-LightBrown.png'),
  lightPurple: require('../../../../../asserts/stars/Star-Active-LightPurple.png'),
  lightYellow: require('../../../../../asserts/stars/Star-Active-LightYellow.png'),
  oceanic: require('../../../../../asserts/stars/Star-Active-Oceanic.png'),
  pink: require('../../../../../asserts/stars/Star-Active-Pink.png'),
  purple: require('../../../../../asserts/stars/Star-Active-Purple.png'),
}

const indexToColor: Record<number, string> = {
  0: 'brown',
  1: 'lightBrown',
  2: 'lightYellow',
  3: 'green',
  4: 'darkGreen',
  5: 'oceanic',
  6: 'blue',
  7: 'lightPurple',
  8: 'purple',
  9: 'pink',
}

export default memo(StarTile)
